import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import { GetDirectionsComponent } from '../../components/FindPollingStation/GetDirections';
import {
    ConfirmationInfoFullAddress,
    ConfirmationInfoTitle,
    ConfirmationInfoOtherDetails
} from '../../components/FindPollingStation/ConfirmationInfo';

const FindPollingStationSuccessMultiActionsCard = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.otherDetails}
            titleComponent={<TitleComponent titleNoRep={props.title} />}
            getDirectionsComponent={
                <GetDirectionsComponent fullAddress={props.fullAddress} />
            }
            fullAddress={props.fullAddress}
            {...props}
        />
    </TransitionContainerNoExit>
);

FindPollingStationSuccessMultiActionsCard.propTypes = {
    otherDetails: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    fullAddress: PropTypes.string.isRequired
};

export default connect(
    state => {
        const completeFindPollingStation =
            state.findPollingStation.completeFindPollingStation;

        return {
            title: ConfirmationInfoTitle(completeFindPollingStation),
            otherDetails: ConfirmationInfoOtherDetails(completeFindPollingStation),
            fullAddress: ConfirmationInfoFullAddress(completeFindPollingStation),
            googleMapIsLoaded: state.findPollingStation.googleMapIsLoaded
        };
    },
    {}
)(FindPollingStationSuccessMultiActionsCard);



// WEBPACK FOOTER //
// ./src/containers/FindPollingStation/FindPollingStationSuccessMultiActionCard.jsx